import css from '@styled-system/css'
import * as React from 'react'
import styled, { StyledComponent, ThemeContext } from 'styled-components'
import {
  color,
  ColorProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system'

const SvgIcon = (
  props: React.SVGProps<SVGSVGElement> & {
    size?: number | string
    color?: string
  },
) => {
  const { size } = props

  if (size != null) {
    props = {
      width: size,
      height: size,
      ...props,
    }
  }

  const themeContext = React.useContext(ThemeContext)

  if (props.color != null) {
    props = { ...props, color: themeContext.colors[props.color] || props.color }
  }

  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#idcard_svg__clip0)">
        <path
          d="M27.061 42.828a9.116 9.116 0 01-5.074-1.548 9.197 9.197 0 01-3.354-4.1 9.212 9.212 0 01-.516-5.274 9.084 9.084 0 012.494-4.672 8.988 8.988 0 014.673-2.494 9.213 9.213 0 015.275.516 9.197 9.197 0 014.099 3.354 9.117 9.117 0 011.548 5.074 9.041 9.041 0 01-2.695 6.45 9.041 9.041 0 01-6.45 2.694zm0-13.588a4.38 4.38 0 00-2.465.746 4.157 4.157 0 00-1.634 2.006 4.414 4.414 0 00-.258 2.58c.172.86.602 1.663 1.233 2.294.63.63 1.404 1.06 2.293 1.232.86.172 1.749.086 2.58-.258a4.665 4.665 0 002.007-1.634 4.519 4.519 0 00.745-2.465 4.378 4.378 0 00-1.319-3.153 4.357 4.357 0 00-3.182-1.348zm13.072 32.222H14.018c-.63 0-1.204-.258-1.663-.688a2.365 2.365 0 01-.688-1.663v-9.059a7.01 7.01 0 012.064-4.96 7.01 7.01 0 014.96-2.063c.229 0 .487.029.716.115.029 0 3.87 1.204 7.511 1.204 3.87 0 7.826-1.204 7.883-1.204.23-.058.459-.115.688-.115a7.01 7.01 0 014.96 2.064 7.01 7.01 0 012.064 4.96v9.058a2.338 2.338 0 01-.688 1.663c-.23.229-.488.4-.774.516-.316.086-.602.172-.918.172zM16.37 56.76h21.414v-6.708c0-.573-.201-1.118-.602-1.548-.373-.43-.889-.688-1.462-.774-1.233.344-5.017 1.29-8.83 1.29-3.64 0-7.281-.946-8.485-1.29a2.235 2.235 0 00-1.462.774 2.35 2.35 0 00-.573 1.548v6.708zm67.28 18.347H2.351c-.631 0-1.204-.258-1.663-.688A2.365 2.365 0 010 72.756V13.244c0-.63.258-1.204.688-1.662a2.365 2.365 0 011.663-.688h81.327c.63 0 1.204.258 1.663.688.43.43.688 1.032.688 1.662v59.54c0 .632-.258 1.205-.688 1.664-.459.4-1.061.659-1.692.659zM4.673 70.434h76.626V15.566H4.673v54.868zm65.99-31.132H49.507c-.63 0-1.204-.258-1.662-.688a2.365 2.365 0 01-.688-1.662c0-.631.258-1.204.688-1.663a2.365 2.365 0 011.662-.688h21.156c.631 0 1.204.258 1.663.688.43.43.688 1.032.688 1.663 0 .63-.258 1.204-.688 1.662-.459.43-1.032.688-1.663.688zM66.994 51.4H49.479c-.631 0-1.204-.258-1.663-.688a2.365 2.365 0 01-.688-1.663c0-.63.258-1.204.688-1.663a2.365 2.365 0 011.663-.688h17.515a2.338 2.338 0 011.663.688c.229.23.401.488.516.774.114.287.172.602.172.889a2.338 2.338 0 01-.688 1.663c-.23.229-.488.4-.774.516-.258.086-.574.172-.889.172z"
          fill={props.color || '#000'}
        />
      </g>
      <defs>
        <clipPath id="idcard_svg__clip0">
          <path fill="#fff" d="M0 0h86v86H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

type StyledSystemProps = TypographyProps &
  SpaceProps &
  LayoutProps &
  ColorProps &
  PositionProps

const _style = (
  component: React.FC,
): StyledComponent<
  React.FC<
    React.SVGProps<SVGSVGElement> & {
      size?: number | string
      color?: string
    }
  >,
  Record<string, unknown>,
  StyledSystemProps,
  never
> => {
  const styledSystemProps = [typography, space, layout, color, position]
  return styled(component)(css({}), styledSystemProps)
}

const SvgIdcard = _style(SvgIcon)

export default SvgIdcard
